import { render } from "./MobilityLogo.vue?vue&type=template&id=2c584041&scoped=true&ts=true"
import script from "./MobilityLogo.vue?vue&type=script&lang=ts"
export * from "./MobilityLogo.vue?vue&type=script&lang=ts"

import "./MobilityLogo.vue?vue&type=style&index=0&id=2c584041&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c584041"]])

export default __exports__